import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	serviceProjectInformation: {
		id: 'servicedesk-settings-customer-portal-v2.customer-portal-forms.service-project-information',
		defaultMessage: 'Service project information',
		description:
			'Header on the Jira Service Management project settings page for Customer portal settings',
	},
	channelAccess: {
		id: 'servicedesk-settings-customer-portal-v2.customer-portal-forms.channel-access',
		defaultMessage: 'Channel access',
		description:
			'Header on the JSM project settings page for displaying customer permissions on portal',
	},
	announcements: {
		id: 'servicedesk-settings-customer-portal-v2.customer-portal-forms.announcements',
		defaultMessage: 'Announcements',
		description: 'Header on the JSM project settings page for Customer portal settings',
	},
	name: {
		id: 'servicedesk-settings-customer-portal-v2.customer-portal-forms.name',
		defaultMessage: 'Name',
		description: 'Change name of the project in customer portal settings',
	},
	introText: {
		id: 'servicedesk-settings-customer-portal-v2.customer-portal-forms.intro-text',
		defaultMessage: 'Introduction text',
		description: 'Change introduction text of the project in customer portal settings',
	},
	noSavePrompt: {
		id: 'servicedesk-settings-customer-portal-v2.customer-portal-forms.no-save-prompt',
		defaultMessage: 'Changes you have made have not been saved.',
		description:
			'Main text on modal that shows up when user attempts to navigate away from unsaved page.',
	},
	instructionForMandatoryField: {
		id: 'servicedesk-settings-customer-portal-v2.customer-portal-forms.instruction-for-mandatory-field',
		defaultMessage: 'Required fields are marked with an asterisk',
		description: 'This is an instruction which states fields with an asterisk (*) are compulsary',
	},
});
